var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "AIExploit" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShow && _vm.parentShow,
              expression: "isShow && parentShow",
            },
          ],
          class: ["AIExploit_wrap", _vm.isTrade ? "_bgImg" : ""],
        },
        [
          _c("div", { staticClass: "AIExploit_top" }, [
            _c("span", { staticClass: "AIExploit_header" }, [
              _vm._v(_vm._s(_vm.$i18.language("TradeGPT-AI拓展关键词"))),
            ]),
            _vm.showOperation
              ? _c(
                  "span",
                  {
                    staticClass: "AIExploit_operation",
                    attrs: { tabindex: "1" },
                  },
                  [
                    _c(
                      "el-link",
                      {
                        staticClass: "operation_change",
                        attrs: { tabindex: "1", underline: false },
                        on: {
                          click: function ($event) {
                            return _vm.changeOperation("refresh")
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.$i18.language("换一批申报词"))),
                        _c("svg-icon", {
                          staticClass: "change-lot",
                          attrs: { name: "change-lot" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" |  "),
                    _c(
                      "el-link",
                      {
                        attrs: { underline: false },
                        on: {
                          click: function ($event) {
                            return _vm.changeOperation("del")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$i18.language("已删除推荐词")))]
                    ),
                    _vm._v(" |  "),
                    _c(
                      "el-link",
                      {
                        attrs: { underline: false },
                        on: {
                          click: function ($event) {
                            return _vm.changeOperation("hide")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$i18.language("隐藏")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "AIExploit_bottom" }, [
            _vm.synonym.result.length || _vm.whoLoading.synonym
              ? _c(
                  "div",
                  { staticClass: "flex_box" },
                  [
                    _c(
                      "span",
                      { staticClass: "words_label" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$i18.language("商品近义词")) + "："
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              width: "300",
                              placement: "right",
                              trigger: "hover",
                              "popper-class": "my-customer-popover",
                              content: _vm.$i18.language(
                                "指含义上非常相似或可以互换使用的词汇。由于同一个商品可能存在多种叫法，在搜索时可以增加找到相关商品的可能性。例如：“运动鞋”，近义词可能包括“跑鞋”、“训练鞋”等。"
                              ),
                            },
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "ai-ex-help",
                              attrs: { slot: "reference", name: "ai-ex-help" },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.whoLoading.synonym
                      ? _c(
                          "span",
                          { staticClass: "words_value" },
                          [
                            _vm._l(_vm.synonym.result, function (el, idx) {
                              return [
                                el.showTooltip
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        key: el.value,
                                        attrs: { content: el.value },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            class: [
                                              _vm.selectedWords.includes(
                                                el.value
                                              )
                                                ? "wordsSelected"
                                                : "",
                                            ],
                                            style: {
                                              width: _vm.tagWidth + "px",
                                            },
                                            attrs: { closable: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addwords(el)
                                              },
                                              close: function ($event) {
                                                return _vm.delwords(
                                                  el,
                                                  "synonym",
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "tag-name-text" },
                                              [_vm._v(_vm._s(el.value))]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "el-tag",
                                      {
                                        key: el.value,
                                        class: [
                                          _vm.selectedWords.includes(el.value)
                                            ? "wordsSelected"
                                            : "",
                                        ],
                                        style: { width: _vm.tagWidth + "px" },
                                        attrs: { closable: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addwords(el)
                                          },
                                          close: function ($event) {
                                            return _vm.delwords(
                                              el,
                                              "synonym",
                                              idx
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "tag-name-text" },
                                          [_vm._v(_vm._s(el.value))]
                                        ),
                                      ]
                                    ),
                              ]
                            }),
                          ],
                          2
                        )
                      : _c("el-skeleton", {
                          staticStyle: { width: "100%" },
                          attrs: { animated: "", rows: 2 },
                        }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.gt.result.length || _vm.whoLoading.gt
              ? _c(
                  "div",
                  { staticClass: "flex_box" },
                  [
                    _c(
                      "span",
                      { staticClass: "words_label" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$i18.language("申报名称词")) + "："
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              width: "300",
                              placement: "right",
                              trigger: "hover",
                              "popper-class": "my-customer-popover",
                              content: _vm.$i18.language(
                                "指商品在进行国际贸易时的可能会使用的海关申报常用词。"
                              ),
                            },
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "ai-ex-help",
                              attrs: { slot: "reference", name: "ai-ex-help" },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.whoLoading.gt
                      ? _c(
                          "span",
                          { staticClass: "words_value" },
                          [
                            _vm._l(_vm.gt.result, function (el, idx) {
                              return [
                                el.showTooltip
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        key: el.value,
                                        attrs: { content: el.value },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            class: [
                                              _vm.selectedWords.includes(
                                                el.value
                                              )
                                                ? "wordsSelected"
                                                : "",
                                            ],
                                            style: {
                                              width: _vm.tagWidth + "px",
                                            },
                                            attrs: { closable: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addwords(el)
                                              },
                                              close: function ($event) {
                                                return _vm.delwords(
                                                  el,
                                                  "gt",
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "tag-name-text" },
                                              [_vm._v(_vm._s(el.value))]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "el-tag",
                                      {
                                        key: el.value,
                                        class: [
                                          _vm.selectedWords.includes(el.value)
                                            ? "wordsSelected"
                                            : "",
                                        ],
                                        style: { width: _vm.tagWidth + "px" },
                                        attrs: { closable: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addwords(el)
                                          },
                                          close: function ($event) {
                                            return _vm.delwords(el, "gt", idx)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "tag-name-text" },
                                          [_vm._v(_vm._s(el.value))]
                                        ),
                                      ]
                                    ),
                              ]
                            }),
                          ],
                          2
                        )
                      : _c("el-skeleton", {
                          staticStyle: { width: "100%" },
                          attrs: { animated: "", rows: 2 },
                        }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.industry.result.length || _vm.whoLoading.industry
              ? _c(
                  "div",
                  { staticClass: "flex_box" },
                  [
                    _c(
                      "span",
                      { staticClass: "words_label" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$i18.language("相关行业词")) + "："
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              width: "300",
                              placement: "right",
                              trigger: "hover",
                              "popper-class": "my-customer-popover",
                              content: _vm.$i18.language(
                                "指采购相关商品的上下游行业中的采购商，经常会进行采购的产品词。这些词汇可以帮助用户发现与原关键词相关的其他潜在商品或服务，拓宽搜索范围。"
                              ),
                            },
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "ai-ex-help",
                              attrs: { slot: "reference", name: "ai-ex-help" },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.whoLoading.industry
                      ? _c(
                          "span",
                          _vm._l(_vm.industry.result, function (item, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "industry_wrap" },
                              [
                                _c("span", { staticClass: "words_text" }, [
                                  _vm._v(_vm._s(item.description) + ": "),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "words_value" },
                                  [
                                    _vm._l(
                                      item.subRecommendKeywords,
                                      function (el, idx) {
                                        return [
                                          el.showTooltip
                                            ? _c(
                                                "el-tooltip",
                                                {
                                                  key: el.value,
                                                  attrs: { content: el.value },
                                                },
                                                [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      class: [
                                                        _vm.selectedWords.includes(
                                                          el.value
                                                        )
                                                          ? "wordsSelected"
                                                          : "",
                                                      ],
                                                      style: {
                                                        width:
                                                          _vm.tagWidth + "px",
                                                      },
                                                      attrs: { closable: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addwords(
                                                            el
                                                          )
                                                        },
                                                        close: function (
                                                          $event
                                                        ) {
                                                          return _vm.delwords(
                                                            el,
                                                            "industry"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tag-name-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(el.value)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "el-tag",
                                                {
                                                  key: el.value,
                                                  class: [
                                                    _vm.selectedWords.includes(
                                                      el.value
                                                    )
                                                      ? "wordsSelected"
                                                      : "",
                                                  ],
                                                  style: {
                                                    width: _vm.tagWidth + "px",
                                                  },
                                                  attrs: { closable: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addwords(el)
                                                    },
                                                    close: function ($event) {
                                                      return _vm.delwords(
                                                        el,
                                                        "industry"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tag-name-text",
                                                    },
                                                    [_vm._v(_vm._s(el.value))]
                                                  ),
                                                ]
                                              ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("el-skeleton", {
                          staticStyle: { width: "100%" },
                          attrs: { animated: "", rows: 3 },
                        }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "merge-dialog dialog-deltekeyWords",
          attrs: {
            title: _vm.$i18.language("已删除推荐关键词"),
            visible: _vm.deleteKeyWordsVisible,
            "destroy-on-close": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteKeyWordsVisible = $event
            },
            close: _vm.closedeleteKeyWordDialog,
          },
        },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "mini" },
              on: { change: _vm.changeDelType },
              model: {
                value: _vm.deleteKeyWordsParams.deleteKeyWordsType,
                callback: function ($$v) {
                  _vm.$set(_vm.deleteKeyWordsParams, "deleteKeyWordsType", $$v)
                },
                expression: "deleteKeyWordsParams.deleteKeyWordsType",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: "gt" } }, [
                _vm._v(_vm._s(_vm.$i18.language("申报名称词"))),
              ]),
              _c("el-radio-button", { attrs: { label: "synonym" } }, [
                _vm._v(_vm._s(_vm.$i18.language("商品近义词"))),
              ]),
              _c("el-radio-button", { attrs: { label: "industry" } }, [
                _vm._v(_vm._s(_vm.$i18.language("相关行业词"))),
              ]),
            ],
            1
          ),
          _c(
            "main-table",
            {
              staticClass: "merge-table table-bottom",
              attrs: {
                data: _vm.deleteKeyWordsList,
                loading: _vm.deleteKeyWordTableLoading,
                "show-page": true,
                "show-index": false,
                "show-search": false,
              },
              on: {
                "change-page": _vm.changeDeleteKeyWordPage,
                "change-page-size": _vm.changeDeleteKeyWordSize,
              },
              scopedSlots: _vm._u([
                {
                  key: "operate",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "operation" }, [
                        _c(
                          "div",
                          {
                            staticClass: "text-btn",
                            class: _vm.isActiveRestoreFn(scope.row.id)
                              ? "text-btn-color"
                              : "text-btn",
                            on: {
                              click: function ($event) {
                                return _vm.restoreKeyWords(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isActiveRestoreFn(scope.row.id)
                                  ? _vm.$i18.language("已恢复")
                                  : _vm.$i18.language("恢复")
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c("empty", {
                staticClass: "empty-table",
                attrs: { slot: "empty" },
                slot: "empty",
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }